import { render, staticRenderFns } from "./AddTouchpoint.vue?vue&type=template&id=1f88087a"
import script from "./AddTouchpoint.vue?vue&type=script&lang=js"
export * from "./AddTouchpoint.vue?vue&type=script&lang=js"
import style0 from "./AddTouchpoint.vue?vue&type=style&index=0&id=1f88087a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports